var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification",class:_vm.classes},[(_vm.icon)?_c('ion-icon',{staticClass:"notification__icon",attrs:{"name":_vm.icon}}):_vm._e(),_c('div',{staticClass:"notification__text"},[_vm._t("default")],2),(_vm.hasControls)?_c('div',{staticClass:"notification__controls"},[_vm._t("controls")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }